import React from 'react';

const BASE =
  'w-full bg-white border rounded-md h-10 px-3 text-[13px] outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/10 placeholder:text-slate-400';

const STATE = {
  default: 'border-slate-200',
  error:   'border-rose-400 ring-2 ring-rose-100',
  success: 'border-emerald-400 ring-2 ring-emerald-50',
};

export function Label({ children, required, htmlFor }) {
  return (
    <label
      htmlFor={htmlFor}
      className="text-[11px] font-semibold text-slate-600 uppercase tracking-wide mb-1.5 block"
    >
      {children}
      {required && <span className="text-rose-500 ml-0.5">*</span>}
    </label>
  );
}

export function Input({
  state = 'default',
  leadingIcon: LeadingIcon,
  trailingIcon: TrailingIcon,
  className = '',
  ...props
}) {
  const hasLeading  = Boolean(LeadingIcon);
  const hasTrailing = Boolean(TrailingIcon);

  if (!hasLeading && !hasTrailing) {
    return (
      <input
        className={`${BASE} ${STATE[state] || STATE.default} ${className}`}
        {...props}
      />
    );
  }

  return (
    <div className="relative">
      {hasLeading && (
        <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
          <LeadingIcon size={14} strokeWidth={1.75} />
        </span>
      )}
      <input
        className={`${BASE} ${STATE[state] || STATE.default} ${hasLeading ? 'pl-8' : ''} ${hasTrailing ? 'pr-8' : ''} ${className}`}
        {...props}
      />
      {hasTrailing && (
        <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
          <TrailingIcon size={14} strokeWidth={1.75} />
        </span>
      )}
    </div>
  );
}

export function Select({ state = 'default', className = '', children, ...props }) {
  return (
    <select
      className={`${BASE} ${STATE[state] || STATE.default} cursor-pointer ${className}`}
      {...props}
    >
      {children}
    </select>
  );
}

export function FormField({ label, required, helper, error, success, children }) {
  return (
    <div>
      {label && <Label required={required}>{label}</Label>}
      {children}
      {helper && (
        <p className={`text-[11.5px] mt-1.5 ${error ? 'text-rose-600' : success ? 'text-emerald-600' : 'text-slate-400'}`}>
          {error || success || helper}
        </p>
      )}
    </div>
  );
}

export function ToggleGroup({ options = [], value, onChange }) {
  return (
    <div className="flex bg-white border border-slate-200 rounded-md p-0.5 text-[11px]">
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={`px-2.5 py-1 rounded font-semibold transition ${
            value === opt.value
              ? 'bg-primary text-white'
              : 'text-slate-500 hover:text-slate-700'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default Input;
